/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Fn } from './Fn';

class EnterpriseStatement extends Fn {
    constructor() {
        super();
        this.baseUrl += '/enterpriseStatement';
    }

    findListWithStat({
        statementName,
        statementCode,
        enterpriseId,
        enterpriseName,
        lastOperatorName,
        statusChangeTime,
        remarks,
        enterpriseStatementStatus,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let statusChangeTimeBegin = null;
        let statusChangeTimeEnd = null;
        if (statusChangeTime != null && statusChangeTime.length === 2) {
            [statusChangeTimeBegin, statusChangeTimeEnd] = statusChangeTime;
        }
        return super.get('/findListWithStat', {
            statementName,
            statementCode,
            enterpriseId,
            enterpriseName,
            lastOperatorName,
            statusChangeTimeBegin,
            statusChangeTimeEnd,
            remarks,
            enterpriseStatementStatus,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, enterpriseId, statementName, statementCode, remarks } = {}) {
        return super.post('/save', {
            id,
            enterpriseId,
            statementName,
            statementCode,
            remarks,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    effectStatement({ id }) {
        return super.post('/effectStatement', {
            id,
        });
    }

    completeStatement({ id }) {
        return super.post('/completeStatement', {
            id,
        });
    }
}

export default new EnterpriseStatement();
export { EnterpriseStatement };
